import * as THREE from 'three';
import * as OBC from "@thatopen/components";
import Experience from '../Experience';

//import Experience from '../Experience.js'

export default class World {
    constructor() {

        this.experience = new Experience()

        this.components = this.experience.components;
        this.container = this.experience.container

        // Create a world
        this.world = this.components.get(OBC.Worlds).create(
            OBC.SimpleScene,
            OBC.SimpleCamera,
            OBC.SimpleRenderer
        );

        this.world.scene = new OBC.SimpleScene(this.components);
        this.world.renderer = new OBC.SimpleRenderer(this.components, this.container);
        this.world.camera = new OBC.OrthoPerspectiveCamera(this.components);
        console.log("initial camera:", this.world.camera)

        this.setupScene();
    }

    setupScene() {

        this.world.scene.setup();
    }


}